import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { cn } from "../../lib/utils";
import { motion } from "motion/react";

interface AccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  isLast?: boolean;
}

export default function Accordion({
  title,
  children,
  className,
  isLast = false,
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          "w-full flex items-center gap-2 justify-between border-b border-border cursor-pointer",
          isLast && !isOpen && "border-b-0",
          className
        )}
      >
        <div className="select-none w-full">{title}</div>

        <div className="flex items-center cursor-pointer hover:text-secondary">
          {isOpen ? (
            <ChevronUpIcon className="w-4 h-4" />
          ) : (
            <ChevronDownIcon className="w-4 h-4" />
          )}
        </div>
      </div>

      {isOpen ? (
        <motion.div
          className={cn(isOpen && !isLast && "border-b border-border")}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {children}
        </motion.div>
      ) : null}
    </div>
  );
}
